import React from 'react'
import cn from 'classnames'

import { sortByKey } from 'util/arrays'
import { propFunc } from 'util/functions'

import { SUI } from 'shared/ui'

import styles from './styles.css'

import Tag from './Tag'

const LabelList = ({
  className,
  isEditingTicketTitle,
  labels,
  onDeleteClick,
  ticketId,
}) => {
  if (!labels || labels.length === 0) return null

  return (
    <SUI>
      <div
        id={'createTagModalOpener' /* Do not remove! Needed for positioning */}
        className={cn(styles.labels, className, {
          [styles['labels-hidden']]: isEditingTicketTitle,
        })}
      >
        {sortByKey(labels.filter(e => e), 'name').map(label => (
          <Tag
            color={label.color}
            key={label.id}
            name={label.name}
            onDeleteClick={propFunc(onDeleteClick, ticketId, label)}
          />
        ))}
      </div>
    </SUI>
  )
}

export default LabelList
